import React, { useState, useEffect } from "react";
import axios from "axios";
import { HorizontalBar } from "react-chartjs-2";
import "chartjs-plugin-datalabels";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";

//Custom Components
import ChartCard from "../../components/Cards/ChartCard";
import CardSwitch from "../../components/Cards/CardSwitch";
import CardLegend from "../../components/Cards/CardLegend";
import Loader from "../../components/Loader/Loader";

import { Wrapper } from "../../components";

//MockData
import totalPeopleConfig from "./totalPeopleConfig";
import totalSegmentedPeopleConfig from "./totalSegmentedPeopleConfig";
import {STATE_STATISTICS_BASE_URL} from '../../constants';


//Icons
import { ReactComponent as Provincia } from "../../img/icons/1_Provincia.svg";
import { ReactComponent as AdultosNinos } from "../../img/icons/1_Adultos_ninos.svg";

const useStyles = makeStyles((theme) => ({
  innerGrid: {
    position: "relative",
  },
  barContainer: {
    position: "relative",
    width: "100%",
    height: "55vh",
    [theme.breakpoints.down("lg")]: {
      height: "55vh",
    },
    [theme.breakpoints.down("xs")]: {
      width: (loading) => (loading ? "100%" : "65vh"),
    },
  },
}));

const EvacuadosPorProvincia = (props) => {

  const { campaign, year } = props;


  const APIURL = `${STATE_STATISTICS_BASE_URL}${campaign}`;

  const [visible, setVisible] = useState("left");
  const [homeData, setHomeData] = useState(null);
  const [, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const classes = useStyles(loading);

  async function getData() {
    try {
      setLoading(true);
      const homeData = await axios.get(APIURL).then((data) => {
        return data.data;
      });
      setHomeData(homeData);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleVisible = (newVisible) => {
    setVisible(newVisible);
    getData();
  };

  const totalPeopleArray = homeData
    ? homeData.map((data) => data.totalPeople)
    : [];
  const totalElderlyPeople = homeData
    ? homeData.map((data) => data.totalElderMen + data.totalElderWomen)
    : [];
  const totalAdult = homeData
    ? homeData.map((data) => data.totalMen + data.totalWomen)
    : [];
  const totalUnderAge = homeData
    ? homeData.map((data) => data.totalBoys + data.totalGirls)
    : [];

  const totalPeopleData = totalPeopleConfig(totalPeopleArray);
  const totalSegmentedPeopledata = totalSegmentedPeopleConfig([
    totalElderlyPeople,
    totalAdult,
    totalUnderAge,
  ]);

  const legendOptions = [
    { legend: "Personas Adultas Mayores", color: "#A48AD4", border: "#7E57C2" },
    {
      legend: "Personas jóvenes y adultos",
      color: "#4EC2F7",
      border: "#03A9F4",
    },
    { legend: "Niños y Niñas", color: "#F3B8C4", border: "#F09AAC" },
  ];

  return (
    <Wrapper>
      <Grid container spacing={1} justify="center">
        <Grid className={classes.innerGrid} item xs={10}>
          <CardSwitch sendData={handleVisible}>
            <Provincia />
            <AdultosNinos />
          </CardSwitch>

          {visible === "left" && (
            <>
            <ChartCard
              title={totalPeopleData.title}
              subheader={totalPeopleData.subtitle}
              year={year}
            >
              {totalPeopleData.type === "horizontalbar" && (
                <div className={classes.barContainer}>
                  {loading ? (
                    <Loader />
                  ) : (
                    <HorizontalBar
                      data={totalPeopleData.data}
                      height={totalPeopleData.height}
                      options={totalPeopleData.options}
                    />
                  )}
                </div>
              )}
            </ChartCard>
            </>
          )}
          {visible === "right" && (
            <ChartCard
              title={totalSegmentedPeopledata.title}
              subheader={totalSegmentedPeopledata.subtitle}
              style={{ position: "relative", width: "100%" }}
              height={72}
              year={year}
            >
              {totalSegmentedPeopledata.type === "horizontalbar" && (
                <div className={classes.barContainer}>
                  {loading ? (
                    <Loader />
                  ) : (
                    <>
                      <CardLegend align={"row"} options={legendOptions} />
                      <HorizontalBar
                        data={totalSegmentedPeopledata.data}
                        height={totalSegmentedPeopledata.height}
                        options={totalSegmentedPeopledata.options}
                      />
                    </>
                  )}
                </div>
              )}
            </ChartCard>
          )}
        </Grid>
      </Grid>
    </Wrapper>
  );
};

export default EvacuadosPorProvincia;
